export enum SwapTab {
  Swap = 'swap',
  Limit = 'limit',
  Send = 'send',
  Buy = 'buy',
}
